/*eslint-disable*/

function Section6() {
    return (
        <div className="section6">
            <video controls={false} muted autoPlay loop style={{ objectFit: "cover" }}>
                <source src={`${process.env.PUBLIC_URL}/words.webm`} type="video/mp4" />
            </video>
        </div>
    )
}

export default Section6